<template>
  <div>
    <div
      v-for="message in messages" :key="message.id"
      :class="$style.item"
    >
      <div :class="$style.subject">{{ message.properties.subject }}</div>
      <div :class="$style.side">
        {{ message.created + 'Z' | date('Pp') }}
        <BaseIcon
          name="external-link-square-alt"
          :class="$style.icon"
          @click="goToMessage(message)"
        />
      </div>
    </div>
    <infinite-loading
      :class="$style.infiniteLoading"
      @infinite="infiniteHandler"
    >
      <Spinner slot="spinner" />
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/Spinner'
import api from '@/api'

export default {
  name: 'profile-shared-subjects',
  components: {
    InfiniteLoading,
    Spinner
  },
  props: {
    chat: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      page: 1,
      messages: []
    }
  },
  methods: {
    fetch () {
      return api.chats.mediaSubjects(this.chat.id, {
        page: this.page
      })
    },
    async infiniteHandler ($state) {
      const { data } = await this.fetch()
      if (data.length) {
        this.messages = this.messages.concat(data)
        $state.loaded()
        this.page += 1
      } else {
        $state.complete()
      }
    },
    goToMessage (message) {
      this.$modal.hide('profile')
      this.$router.push({
        name: 'app-chat',
        query: {
          id: message.chatId,
          highlightedMessageId: message.id
        }
      }).catch(e => {})
    }
  }
}
</script>

<style module lang="scss">
.item {
  padding: 10px 10px;
  display: flex;
  &:not(:first-child) {
    border-top: 1px solid $border-color;
  }
}
.subject {
  flex-grow: 1;
}
.side {
  color: $text-mid-dark;
  font-size: 12px;
}
.icon {
  font-size: 16px;
  margin-left: 4px;
  cursor: pointer;
  &:hover {
    color: $text-colored;
  }
}
.infiniteLoading {
  height: 50px;
  padding: 20px 0;
  margin: 0 auto;
  flex-basis: 100%;
}
</style>
